import { useQuery } from '@apollo/client'
import { GetModuleAvailabilitiesDocument } from 'generated/resources/graphql'

import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'

const emptyModuleAvailability = (moduleIds?: string[]): ModuleAvailabilityType[] => {
  if (typeof moduleIds === 'undefined') {
    return [{ available: false, id: 'unknown', _internalType: 'module' }]
  }

  return moduleIds.map((id) => {
    return { available: false, id: id, _internalType: 'module' }
  })
}

// Get the module availabilities for the current company or a specific one.
//
// The availability of a module is derived of the availabilities of the features that formed the module.
// If one featue is available the module will be available
// Examples:
//
// - Get all module availabilities:
//    `useModuleAvailabilities()`
// - Get the module availability of multiple modules
//    `useModuleAvailabilities(['expenses', 'ats'])`
// - Get the module availability of a specific company
//    `useModuleAvailabilities(['payroll'], companyId)`
/**
 * @deprecated Please include this query into the Page query
 */
export const useModuleAvailabilities = (moduleIds?: string[], companyId?: string) => {
  const { loading, data, refetch } = useQuery(GetModuleAvailabilitiesDocument, {
    variables: {
      ...(moduleIds && { ids: moduleIds }),
      companyId,
    },
  })

  const moduleAvailabilities =
    data?.companies.moduleAvailabilities ?? emptyModuleAvailability(moduleIds)

  return {
    fetching: loading,
    loading: loading && !data,
    refetch,
    moduleAvailabilities,
  }
}
